import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import SearchResultCount from "~/Components/Search/SearchResultCount.vue";
import SearchResults from "~/Components/Search/SearchResults.vue";
import SearchPagination from "~/Components/Search/SearchPagination.vue";
import SearchFilters from "~/Components/Search/SearchFilters.vue";
import AggregateSearch from "~/Components/Search/AggregateSearch.vue";

new VueApp( {
  name: "Search",
  components: {
    SearchResults,
    SearchPagination,
    SearchFilters,
    AggregateSearch,
    SearchResultCount
  },
  data: () => ( {
    numResults: 0
  } ),
  methods: {
    updateNumResults ( val ) {
      this.numResults = val ?? 0;
    }
  }
} );
